module.exports = __webpack_public_path__ + "img/sup_deposit_mtpay2.2b09aa8b.jpg";